export default __webpack_public_path__ + "static/media/imagen_grupos.a0cac334.png";